import { BUNDLE_SKU, COFFEE_BUNDLE_SKU } from '@/services/constants'
import type { CartItem } from '@/types/shopify'

export const getProp = <T extends HasProperties>(item: T, propName: string): string | number | undefined => {
  // if (Array.isArray(item.customAttributes)) {
  //   return item.customAttributes.find(attribute => attribute.key === propName)?.value
  // }
  if (Array.isArray(item.properties)) {
    return item.properties.find(property => property.name === propName)?.value
  } else if (item.properties) {
    return item.properties[propName]
  }
}

export const isSubscriptionItem = (item: CartItem) => (
  !!item.selling_plan_allocation || !!getProp(item, 'shipping_interval_frequency')
)

export const isBundleItem = (item: CartItem) => {
  return BUNDLE_SKU.test(String(item.sku)) || COFFEE_BUNDLE_SKU.test(String(item.sku))
}

export const sumQuantity = (items: { quantity: number }[]): number => items.reduce((total, item) => total + item.quantity, 0)
